import Vue from 'vue'
import request from '@/helpers/request'
import snack from '@/helpers/snack'
import router from '@/router'

export default {
  GET_EQUIPMENT_TYPES: ({ commit, state }, payload) => {
    return new Promise((resolve, reject) => {
      request(
        'GET',
        `${Vue.config.server}/${Vue.config.modules.crm.api.equipmentTypes.all}`,
        {
          params: payload.params,
        },
        true,
      )
        .then(response => {
          const data = response.data.data
          commit('setEquipmentTypes', data.items)
          commit('setEquipmentTypeFilters', data.filters)
          commit('setLoad', false)

          resolve(data.count)
        })
        .catch(() => {
          snack.add(Vue.config.localization.ru.notFoundMessage)

          reject()
        })
    })
  },
  GET_EQUIPMENT_TYPE: ({ commit, state }, payload) => {
    return new Promise((resolve, reject) => {
      if (payload.showPreloader) {
        commit('setLoad', true)
      }

      request(
        'GET',
        `${Vue.config.server}/${Vue.config.modules.crm.api.equipmentTypes.one.replace('$1', payload.item)}`,
        {
          params: {
            with: 'places',
          },
        },
        true,
      ).then(response => {
        if (response.data.result === 'success') {
          const item = response.data.data
          commit('setEquipmentType', item)
          commit('setLoad', false)
        } else {
          snack.add(Vue.config.localization.ru.notFoundMessage)
        }

        resolve()
      })
    })
  },
  CREATE_EQUIPMENT_TYPE: ({ commit, state }) => {
    return new Promise((resolve, reject) => {
      commit('setLoad', true)

      request(
        'POST',
        `${Vue.config.server}/${Vue.config.modules.crm.api.equipmentTypes.all}`,
        {
          title: state.equipmentType.title,
          place_ids: state.equipmentType.places.map(place => place.id),
        },
        true,
      ).then(response => {
        if (response.data.result === 'success') {
          const data = response.data
          commit('setEquipmentTypeField', { id: data.data.id })
          commit('prependEquipmentTypes', state.equipmentType)

          router.push({ path: Vue.config.modules.crm.route.equipmentTypes.one.replace('$1', data.data.id) })
          snack.add(Vue.config.localization.ru.savedMessage, 'primary')
        } else {
          snack.add(Vue.config.localization.ru.notFoundMessage)
        }
      })

      commit('setLoad', false)
      resolve()
    })
  },
  UPDATE_EQUIPMENT_TYPE: ({ commit, state }) => {
    return new Promise((resolve, reject) => {
      commit('setLoad', true)

      request(
        'PUT',
        `${Vue.config.server}/${Vue.config.modules.crm.api.equipmentTypes.one.replace('$1', state.equipmentType.id)}`,
        {
          title: state.equipmentType.title,
          place_ids: state.equipmentType.places.map(place => place.id),
        },
        true,
      ).then(response => {
        if (response.data.result === 'success') {
          commit('changeEquipmentType', state.equipmentType)

          snack.add(Vue.config.localization.ru.savedMessage, 'primary')
        } else {
          snack.add(Vue.config.localization.ru.notFoundMessage)
        }
      })

      commit('setLoad', false)
      resolve()
    })
  },
  DELETE_EQUIPMENT_TYPE: ({ commit, state, dispatch }) => {
    return new Promise((resolve, reject) => {
      commit('setLoad', true)

      request(
        'DELETE',
        `${Vue.config.server}/${Vue.config.modules.crm.api.equipmentTypes.one.replace('$1', state.equipmentType.id)}`,
        {},
        true,
      ).then(response => {
        if (response.data.result === 'success') {
          commit('deleteEquipmentType', state.equipmentType.id)

          snack.add(Vue.config.localization.ru.deleteMessage, 'primary')
        } else {
          snack.add(Vue.config.localization.ru.notFoundMessage)
        }

        const item = _.first(state.equipmentTypes)

        if (item) {
          dispatch('GET_EQUIPMENT_TYPE', {
            item: item.id,
          }).then(() => {
            router.push({ path: Vue.config.modules.crm.route.equipmentTypes.one.replace('$1', item.id) })
            resolve()
          })
        } else {
          router.push({ path: Vue.config.modules.crm.route.equipmentTypes.all })
          resolve()
        }

        commit('setLoad', false)
      })
    })
  },

  async GET_EQUIPMENT_TYPE_WITH_EXTRA({ commit, dispatch }, payload) {
    commit('setLoad', true)
    await Promise.all([
      dispatch('GET_EQUIPMENT_PLACES'),
      dispatch('GET_EQUIPMENT_TYPES', payload),
      dispatch('GET_EQUIPMENT_TYPE', payload),
    ])
    commit('setLoad', false)
  },

  async GET_EQUIPMENT_TYPE_EXTRA({ commit, dispatch }, payload) {
    commit('setLoad', true)
    await Promise.all([dispatch('GET_EQUIPMENT_PLACES'), dispatch('GET_EQUIPMENT_TYPES', payload)])
    commit('setLoad', false)
  },
}
